module.exports = __webpack_public_path__ + "static/media/U1-T2-5-1.d944be8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-5-1.svg
// module id = 598
// module chunks = 0